import React from 'react';
import GoogleMapsProvider from './src/components/loaders/GoogleMapsProvider';
import LandingUrlSetter from './src/components/LandingUrlSetter';
import './src/styles/global.css';

export const wrapRootElement = ({ element }) => <GoogleMapsProvider>{element}</GoogleMapsProvider>;

export const wrapPageElement = ({ element }) => <LandingUrlSetter>{element}</LandingUrlSetter>;
